import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {Alert, View} from '@instructure/ui'

const ALERT_AUTO_TIMEOUT = 5000;

export function Alerts({ alerts = [], onDismiss = () => {} }) {
  const liveRegion = useRef(null);
  return (
      <>
        <div className="alerts-container" role="alert" ref={liveRegion} />
        {alerts.map((alert, id) => (
            <View key={alert.key} display="block" margin="0 small">
              <Alert
                  variant={alert.variant}
                  renderCloseButtonLabel={alert.undismissable ? undefined : 'Dismiss alert'}
                  margin="xx-small 0"
                  timeout={alert.locked ? null : ALERT_AUTO_TIMEOUT}
                  onDismiss={() => onDismiss(id)}
                  liveRegion={() => liveRegion.current}
                  liveRegionPoliteness="polite"
                  isLiveRegionAtomic={true}
              >
                {alert.message}
              </Alert>
            </View>
        ))}
      </>
  )
}

Alerts.propTypes = {
  alerts: PropTypes.array.isRequired,
  onDismiss: PropTypes.func,
}

let id = 0

/**
 * Builds an error message. These messages are locked and will not disappear without user interaction.
 * @param message The message to display.
 */
export const buildError = (message) => ({
  key: 'error-' + id++,
  variant: 'error',
  locked: true,
  message: message
})

/**
 * @deprecated Use buildSuccess() instead
 */
export const buildMessage = (message) => ({
  key: 'message-' + id++,
  variant: 'success',
  message: message
})

/**
 * Builds a success message. These messages are not locked and will disappear after 5 seconds.
 * @param message The message to display.
 */
export const buildSuccess = (message) => ({
  key: 'message-' + id++,
  variant: 'success',
  message: message
})

/**
 * an undismissable warning
 * @param message
 * @returns {{variant: string, message, locked: boolean, undismissable: boolean, key: string}}
 */
export const buildWarning = (message) => ({
  key: 'message-' + id++,
  variant: 'warning',
  message: message,
  locked: true,
  undismissable: true
})
